import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { useAuthStore } from './stores/auth'
import { queryClient } from './lib/queryClient'
import { RouterContext } from './routerContext'
import PageShell from './components/Common/PageShell'
import ErrorState from './components/Common/ErrorState'
import { QueryErrorResetBoundary } from '@tanstack/react-query'
import { ErrorBoundary } from 'react-error-boundary'

// Custom global error component
const GlobalError = ({ error }: { error: Error; resetErrorBoundary: () => void }) => {
  return (
    <PageShell title="Error" fullWidth>
      <ErrorState title="Error loading dashboard" message={error.message} />
    </PageShell>
  )
}

export const router = createRouter({
  routeTree,
  defaultErrorComponent: () => (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          fallbackRender={({ error, resetErrorBoundary }) => (
            <GlobalError error={error} resetErrorBoundary={resetErrorBoundary} />
          )}
          onReset={reset}
        />
      )}
    </QueryErrorResetBoundary>
  ),
  context: {
    queryClient,
    auth: {
      isAuthenticated: () => useAuthStore.getState().isAuthenticated(),
      isTokenExpired: () => useAuthStore.getState().isTokenExpired(),
      user: () => useAuthStore.getState().user,
      getAuthHeaders: () => useAuthStore.getState().getAuthHeaders(),
    },
  } as RouterContext,
})
